<template>
  <div class="income">
    <b-table :fields="fields" :items="items" hover small striped responsive>
      <template #thead-top>
        <b-tr>
          <b-th colspan="1"><span class="sr-only">季度/等級</span></b-th>
          <b-th :colspan="levelGroups.length" variant="primary">總市值，百萬</b-th>
          <b-th :colspan="levelGroups.length" variant="info">歸屬母公司淨利（損），百萬</b-th>
          <b-th :colspan="levelGroups.length" variant="success">近四季每股 EPS 本益比(元)</b-th>
        </b-tr>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      levelGroups: ["T", "A", "B", "C", "D"], // 可依需求加上 T 等級
    };
  },
  computed: {
    fields() {
      const baseFields = [{ key: "quarter", label: "季度/等級" }];

      const marketFields = this.levelGroups.map(group => ({
        key: `total_market_capital_${group}`,
        label: group,
        formatter: value => this.formatToCommaStr(value),
        thClass: "text-center",
        tdClass: "text-right"
      }));

      const incomeFields = this.levelGroups.map(group => ({
        key: `net_income_to_stockholders_company_${group}`,
        label: group,
        formatter: value => this.formatToCommaStr(value),
        thClass: "text-center",
        tdClass: "text-right"
      }));

      const EPSFields = this.levelGroups.map(group => ({
        key: `EPS_price_earnings_ratio_${group}`,
        label: group,
        formatter: value => this.formatToCommaStr(value),
        thClass: "text-center",
        tdClass: "text-right"
      }));

      return baseFields.concat(marketFields, incomeFields, EPSFields);
    },

    items() {
      return Object.entries(this.$store.getters.income).map(([quarter, data]) => {
        const item = { quarter };

        this.levelGroups.forEach(group => {
          item[`total_market_capital_${group}`] =
            data.total_market_capital?.[group] === null
              ? this.$store.getters.formateToNA()
              : this.$store.getters.roundDown2DecimalPlace(data.total_market_capital?.[group]);

          item[`net_income_to_stockholders_company_${group}`] =
            data.net_income_to_stockholders_company?.[group] === null
              ? this.$store.getters.formateToNA()
              : this.$store.getters.roundDown2DecimalPlace(data.net_income_to_stockholders_company?.[group]);

          // EPS_price_earnings_ratio
          item[`EPS_price_earnings_ratio_${group}`] =
            data.EPS_price_earnings_ratio?.[group] === null
              ? this.$store.getters.formateToNA()
              : this.$store.getters.roundDown2DecimalPlace(data.EPS_price_earnings_ratio?.[group]);
        });

        return item;
      });
    }
  },
  methods: {
    formatToCommaStr(value) {
      return value.toLocaleString().replace(/-(.+)/g, "($1)");
    }
  }
};
</script>

<style lang="scss" scoped>
.income {}
</style>
